<template>
  <CSidebar
    unfoldable
    dropdownMode="closeInactive"
    colorScheme="dark"
    :minimize="minimize"
    :show.sync="show"
  >
    <!-- <CSidebar size="sm" unfoldable dropdownMode="closeInactive" colorScheme="dark" :minimize="minimize" :show.sync="show"> -->
    <CSidebarBrand
      :imgFull="{ width: 200, height: 70, alt: 'Logo', src: logo }"
      :imgMinimized="{ width: 50, height: 50, alt: 'Logo', src: logo2 }"
    >
      <img
        :src="logo"
        width="200"
        height="70"
        alt="Logo"
        class="c-sidebar-brand-full"
      />
      <!-- <img :src="logo" width="150" height="50" alt="Logo" class="c-sidebar-brand-full" /> -->
      <img
        :src="logo2"
        width="50"
        height="50"
        alt="Logo"
        class="c-sidebar-brand-minimized"
      />
    </CSidebarBrand>
    <CRenderFunction flat :content-to-render="nav" />
    <!-- <CRenderFunction style="font-size: 12px;" flat :content-to-render="nav" /> -->
    <CSidebarBrand
      v-show="imgSideEnabled"
      :imgFull="{ width: 200, height: 70, alt: 'Logo', src: imageSidebar }"
      :imgMinimized="{ width: 50, height: 50, alt: 'Logo', src: imageSidebar }"
    >
      <img
        :src="imageSidebar"
        width="200"
        height="70"
        alt="Logo"
        class="c-sidebar-brand-full"
      />
      <!-- <img :src="imageSidebar"  width="150" height="50" alt="Logo" class="c-sidebar-brand-full" /> -->
    </CSidebarBrand>
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="minimize = !minimize"
    />
  </CSidebar>
</template>

<script>
import nav from "./_nav";
import logo2 from "../assets/images/Logo-Vertical-Blanco.png";
import logo from "../assets/images/Logo-Horizontal-Blanco.png";
import CredentialMixin from '../mixins/CredentialMixin';

export default {
  name: "TheSidebar",
  mixins: [CredentialMixin],
  data() {
    return {
      minimize: false,
      imgSideEnabled: false,
      logo: logo,
      logo2: logo2,
      imageSidebar: null,
      nav_: nav,
      show: "responsive"
    };
  },
  created: function() {
    this.loadImgSide();
  },
  computed: {
    nav() {
      let reduceFilter=function(v, c) {
        const c_copy = JSON.parse(JSON.stringify(c))
        if(c_copy.items){
          c_copy.items = c_copy.items.reduce(reduceFilter, [])
        }
        if(c_copy.credential){
          if(this.hasTheCredential(c_copy.credential)){
            v.push(c_copy)
          }
        } else {
          v.push(c_copy)
        }

        return v
      }
      reduceFilter = reduceFilter.bind(this)
      
      return this.nav_.map(itm=>{
        const { _name, _children } = itm;
        return {_name, _children: _children.reduce(reduceFilter, [])}
      })
    }
  },
  mounted() {
    this.$root.$on("toggle-sidebar", () => {
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
    });
  },
  methods: {
    loadImgSide() {
      this.$store
        .dispatch("customHTTP", {
          schema: "configuracion",
          filter: {
            where: [
              {
                field: "payload->parametro",
                operator: "=",
                value: "imagen_side_menu"
              }
            ]
          }
        })
        .then(response => {
          // if (response.data[0]) {
          this.$store
            .dispatch("customImageObtenerHTTP", {
              media: response.data[0].payload.valor
            })
            .then(image => {
              if (image.type !== "application/json") {
                this.imgSideEnabled = true;
                this.imageSidebar = window.URL.createObjectURL(image);
              } else {
                this.imgSideEnabled = false;
              }
            })
            .catch(() => {
              this.imgSideEnabled = false;
            });
          // }
        })
        .catch(() => {
          this.imgSideEnabled = false;
        });
    }
  }
};
</script>
<style scoped>
.c-sidebar-brand img {
  object-fit: contain;
}
</style>
